import { HoldToConfirmButton } from "@/components/button/hold-to-confirm-button";
import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";
import { LocalStorageKeys } from "@/constants/local-storage-keys";
import { useDeleteUser } from "@/hooks/requests/user/use-delete-user";
import { IonAlert, useIonRouter } from "@ionic/react";
import { useState } from "react";

export default function DeleteAccountPage() {
  const navigation = useIonRouter();
  const { mutateAsync: deleteUser, isPending: isDeleting } = useDeleteUser();

  const [showAlert, setShowAlert] = useState(false);

  const handleDeleteAccount = async () => {
    try {
      await deleteUser();

      localStorage.removeItem(LocalStorageKeys.USER_KEY);
      localStorage.removeItem(LocalStorageKeys.ACCESS_TOKEN_KEY);

      navigation.push("/login", "forward", "replace");
    } catch (error) {
      console.error("Failed to delete account:", error);
    }
  };

  return (
    <PageContainer
      className="h-full w-full app-bar-bottom-padding overflow-y-auto no-scrollbar"
      showLogo={true}
    >
      <PageTitleComponent
        title="Delete Account"
        description="Are you sure you want to delete your account? This action is irreversible."
      />

      <div className="px-4 mt-8 flex flex-col items-center gap-4">
        <div className="bg-red-50 border border-red-200 rounded-2xl p-4 w-full">
          <p className="text-sm text-red-800 text-center">
            ⚠️ This action will permanently delete your account, including all
            your meal plans, preferences, and data. This cannot be undone.
          </p>
        </div>

        <div className="mt-4 w-full">
          <p className="text-sm text-gray-600 text-center mb-4">
            To confirm deletion, press and hold the button below for 5 seconds.
          </p>
        </div>

        <div className="w-full max-w-sm">
          <HoldToConfirmButton
            label="Hold to Delete Account"
            onComplete={() => setShowAlert(true)}
            disabled={isDeleting}
          />
        </div>
      </div>

      <IonAlert
        isOpen={showAlert}
        header="Delete Account"
        message="Are you absolutely sure you want to delete your account? This action cannot be undone."
        mode="ios"
        buttons={[
          {
            text: "Cancel",
            role: "cancel",
            handler: () => {
              setShowAlert(false);
            },
          },
          {
            text: isDeleting ? "Deleting..." : "Yes, Delete",
            role: "destructive",
            handler: handleDeleteAccount,
          },
        ]}
        onDidDismiss={() => setShowAlert(false)}
      />
    </PageContainer>
  );
}
